<template>
  <div class="crud_form_wrapper">
    <!-- Start:: Title -->
    <div class="form_title_wrapper">
      <h4>{{ $t("PLACEHOLDERS.show_course_info") }}</h4>
    </div>
    <div class="col-12 text-end">
      <v-btn @click="$router.go(-1)" style="color: #3eb6d4">
        <i class="fas fa-backward"></i>
      </v-btn>
    </div>
    <!-- End:: Title -->

    <!-- Start:: Single Step Form Content -->
    <div class="single_step_form_content_wrapper">
      <form>
        <div class="row">
          <base-image-upload-input
            col="6"
            identifier="image"
            :placeholder="$t('PLACEHOLDERS.image')"
            @selectImage="selectImage"
            :acceptVideo="true"
            v-if="data.image?.path"
            :preSelectedImage="data.image.path"
            required
            disabled
          />
          <base-image-upload-input
            col="6"
            identifier="video"
            :placeholder="$t('PLACEHOLDERS.video_iden')"
            @selectImage="selectVideo"
            :preSelectedImage="data.video?.path"
            :acceptVideo="true"
            disabled
          />
          <base-input
            col="6"
            type="text"
            :placeholder="$t('PLACEHOLDERS.nameAr')"
            v-model.trim="data.name_ar"
            required
            disabled
          />
          <base-input
            col="6"
            type="text"
            :placeholder="$t('PLACEHOLDERS.nameEn')"
            v-model.trim="data.name_en"
            required
            disabled
          />
          <base-input
            col="6"
            type="textarea"
            :placeholder="$t('PLACEHOLDERS.descAr')"
            v-model.trim="data.desc_ar"
            required
            disabled
          />
          <base-input
            col="6"
            type="textarea"
            :placeholder="$t('PLACEHOLDERS.descEn')"
            v-model.trim="data.desc_en"
            required
            disabled
          />
          <base-input
            col="6"
            type="text"
            :placeholder="$t('PLACEHOLDERS.academic_stage')"
            v-model="data.academic_stage"
            disabled
          />
          <base-input
            col="6"
            type="text"
            :placeholder="$t('PLACEHOLDERS.academic_year')"
            v-model="data.academic_year"
            disabled
          />
          <base-input
            col="6"
            type="text"
            :placeholder="$t('PLACEHOLDERS.course_level')"
            v-model="data.level"
            disabled
          />
          <div
            class="col-12"
            v-for="(item, index) in skills"
            :key="'l' + index"
          >
            <div class="item d-flex align-items-center">
              <base-input
                col="6"
                type="text"
                :placeholder="$t('PLACEHOLDERS.skill_ar')"
                v-model.trim="item.ar"
                disabled
              />
              <base-input
                col="6"
                type="text"
                :placeholder="$t('PLACEHOLDERS.skill_en')"
                v-model.trim="item.en"
                disabled
              />
            </div>
          </div>

          <div class="input_wrapper switch_wrapper my-5 col-6">
            <v-switch
              color="green"
              :label="
                data.active
                  ? $t('PLACEHOLDERS.active')
                  : $t('PLACEHOLDERS.notActive')
              "
              v-model="data.active"
              hide-details
              disabled
            ></v-switch>
          </div>
        </div>
      </form>
    </div>
    <!-- END:: Single Step Form Content -->
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
export default {
  name: "ShowBank",

  
  data() {
    return {
      // Start:: Loader Control Data
      isWaitingRequest: false,
      // End:: Loader Control Data
      skills: [],
      data: {
        academic_year: null,
        academic_stage: null,
        name_ar: null,
        level: null,
        name_en: null,
        image: {
          file: null,
          path: null,
        

},
        video: {
          file: null,
          path: null,
        },
        desc_ar: null,
        desc_en: null,
        active: true,
        count_use: null,
        active: null,
      },
    };
  },

  computed: {
    ...mapGetters({
      getAppLocale: "AppLangModule/getAppLocale",
    }),
  },

  methods: {
    async showCourse() {
      try {
        let res = await this.$axios({
          method: "GET",
          url: `courses/${this.$route.params?.id}`,
        });
        this.data.name_ar = res.data.data.Course.name_ar;
        this.data.name_en = res.data.data.Course.name_en;
        this.data.desc_ar = res.data.data.Course.description_ar;
        this.data.desc_en = res.data.data.Course.description_en;
        this.data.level = res.data.data.Course.level_translation;
        this.data.video.path = res.data.data.Course.video;
        this.data.image.path = res.data.data.Course.image;
        this.skills = res.data.data.Course.skills.map((skill) => ({
          ar: skill.name_ar,
          en: skill.name_en,
        }));
        this.data.academic_stage = res.data.data.Course.academic_stage.name;
        this.data.academic_year = res.data.data.Course.academic_year.name;

        this.data.active = res.data.data.is_active;
      } catch (error) {
        this.loading = false;
        console.log(error?.response?.data?.message);
      }
    },

    async getAcademicStages() {
      try {
        let res = await this.$axios({
          method: "GET",
          url: "academic-stages?page=0&limit=0&is_active=1",
        });
        this.academic_stages = res.data.data.data;
      } catch (error) {
        console.log(error.response.data.message);
      }
    },
    async getAcademicYears() {
      try {
        let res = await this.$axios({
          method: "GET",
          url: `academic-years?page=0&limit=0&is_active=1`,
        });
        this.academic_years = res.data.data.data;
      } catch (error) {
        console.log(error.response.data.message);
      }
    },
  },

  created() {
    this.getAcademicStages();
    this.getAcademicYears();
    this.showCourse();
  },
};
</script>
